import React from 'react';
import { Link } from 'react-router-dom';
import { SxProps, Box, Typography } from '@mui/material';
import { routes } from '../constants';
import Dropdown from '../ui/Dropdown';

type Props = {
  availableIds: Record<string, string>;
  selectedId: string | null;
  setSelectedId: React.Dispatch<React.SetStateAction<string | null>>;
  loading: boolean;
};

/**
 * Header bar component on top of the page
 * 
 * @returns Header bar element
 */
export const HeaderBar = ({ availableIds, selectedId, setSelectedId, loading }: Props): JSX.Element => {

  const containerStyle: SxProps = {
    display: "flex",
    justifyContent: "space-between",
    height: 1,
    width: 1,
    borderBottom: "#eef2f8 1px solid",
    overflow: "hidden",
  };

  const buttonStyle: SxProps = {
    display: "flex",
    alignItems: "center",
    color: "#eff2f8",
    textDecoration: "none",
  };

  const titleStyle: SxProps = {
    margin: "30px",
    fontSize: "24pt",
  };

  const selectContainerStyle: SxProps = {
    display: "flex",
    margin: "auto 30px auto auto",
  };
  
  const selectBoxLabelStyle: SxProps = {
    verticalAlign: "baseline",
    margin: "auto 0 auto auto",
    width: "100px",
    fontSize: "20px",
    color: "#eef2f8",
  };

  return (
    <Box sx={containerStyle}>
      <Box component={Link} to={routes.ClientHistory.path()} sx={buttonStyle}>
        <Typography sx={titleStyle}>InsightCare</Typography>
      </Box>
      <Box sx={selectContainerStyle}>
        <Box sx={selectBoxLabelStyle}>Client ID:</Box>
        <Dropdown
          availableNames={Object.values(availableIds)}
          availableValues={Object.keys(availableIds)}
          selectedValue={selectedId}
          setSelectedValue={setSelectedId}
          loading={loading}
        />
      </Box>
    </Box>
  );
};

export default HeaderBar;
